import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { UpdateDocumentRequest, UpdateDocumentRequestType, UpdateDocumentResponse } from '../models/updateDocument';

export const onGetUpdateDocumentsRequestList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<UpdateDocumentResponse>>('dashboard/actions/update-document', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetUpdateDocumentsRequestById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<UpdateDocumentRequest>>(`dashboard/actions/update-document/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetUpdateDocumentsRequestTypes = async () => {
	try {
		const response = await axios.get<JsonResponse<UpdateDocumentRequestType[]>>(`dashboard/actions/update-document/get-documents`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSubmitUpdateDocumentRequest = async (data: FormData) => {
	try {
		const response = await axios.post<JsonResponse<UpdateDocumentRequest>>(`dashboard/actions/update-document`, data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
